module.exports = __webpack_public_path__ + "img/pt.f96e80e9.svg";